var OrganisationPreference = /** @class */ (function () {
    function OrganisationPreference(data) {
        Object.assign(this, data);
    }
    /**
     * The name of the model represented by this $resource,
     * i.e. `OrganisationPreference`.
     */
    OrganisationPreference.getModelName = function () {
        return "OrganisationPreference";
    };
    /**
    * @method factory
    * @author Jonathan Casarrubias
    * @license MIT
    * This method creates an instance of OrganisationPreference for dynamic purposes.
    **/
    OrganisationPreference.factory = function (data) {
        return new OrganisationPreference(data);
    };
    /**
    * @method getModelDefinition
    * @author Julien Ledun
    * @license MIT
    * This method returns an object that represents some of the model
    * definitions.
    **/
    OrganisationPreference.getModelDefinition = function () {
        return {
            name: 'OrganisationPreference',
            plural: 'OrganisationPreferences',
            path: 'admin/organisationPreferences',
            idName: 'id',
            properties: {
                "autoShareSevere": {
                    name: 'autoShareSevere',
                    type: 'boolean',
                    default: false
                },
                "autoShareHigh": {
                    name: 'autoShareHigh',
                    type: 'boolean',
                    default: false
                },
                "autoShareMid": {
                    name: 'autoShareMid',
                    type: 'boolean',
                    default: false
                },
                "autoShareLow": {
                    name: 'autoShareLow',
                    type: 'boolean',
                    default: false
                },
                "minCheckInShareScore": {
                    name: 'minCheckInShareScore',
                    type: 'number',
                    default: -1
                },
                "maxCheckInShareScore": {
                    name: 'maxCheckInShareScore',
                    type: 'number',
                    default: -1
                },
                "severeConcernWarning": {
                    name: 'severeConcernWarning',
                    type: 'boolean',
                    default: true
                },
                "severeConcernMessage": {
                    name: 'severeConcernMessage',
                    type: 'string',
                    default: 'You have marked this as an alert. In addition to completing this flag, please call the Home Care Office and report your concern to a Coordinator'
                },
                "id": {
                    name: 'id',
                    type: 'string'
                },
                "organisationId": {
                    name: 'organisationId',
                    type: 'string'
                },
                "created": {
                    name: 'created',
                    type: 'Date'
                },
                "lastUpdated": {
                    name: 'lastUpdated',
                    type: 'Date'
                },
                "organisationsId": {
                    name: 'organisationsId',
                    type: 'string'
                },
            },
            relations: {
                organisation: {
                    name: 'organisation',
                    type: 'Organisation',
                    model: 'Organisation',
                    relationType: 'belongsTo',
                    keyFrom: 'organisationId',
                    keyTo: 'id'
                },
            }
        };
    };
    return OrganisationPreference;
}());
export { OrganisationPreference };
//# sourceMappingURL=OrganisationPreference.js.map